import React from 'react';
import { GripHorizontal } from 'lucide-react';
import { PX_PER_SEC, AUDIO_H } from './constants';

export const AudioBlock = ({ segment, isSelected, onClick, onPointerDown }) => {
  const x = (segment.start_time || 0) * PX_PER_SEC;
  const w = Math.max((segment.duration || 1) * PX_PER_SEC, 24);
  const isM = segment.type === 'music';
  const wf = segment.waveform;

  return (
    <div
      className={`absolute top-0.5 rounded cursor-grab transition-shadow select-none ${
        isM ? 'bg-emerald-600/50 border-emerald-500/60' : 'bg-amber-600/50 border-amber-500/60'
      } border ${isSelected ? 'ring-2 ring-white/50 shadow-lg cursor-grabbing' : 'hover:brightness-110'}`}
      style={{ left: x, width: w, height: AUDIO_H - 4, touchAction: 'none' }}
      onClick={(e) => { e.stopPropagation(); onClick(); }}
      onPointerDown={(e) => {
        // setPointerCapture so subsequent move/up events fire on this element
        // even if the user's finger drifts outside its bounds — essential for
        // touch drag on mobile.
        if (e.target.setPointerCapture && e.pointerId != null) {
          try { e.target.setPointerCapture(e.pointerId); } catch (_) { /* noop */ }
        }
        onPointerDown && onPointerDown(e);
      }}
      data-testid={`audio-seg-${segment.id}`}
    >
      {wf && wf.length > 0 && (
        <div className="absolute inset-0 flex items-end overflow-hidden rounded pointer-events-none px-px" style={{ opacity: 0.35 }}>
          {wf.map((amp, i) => (
            <div key={i} className={`min-w-[1px] rounded-t-sm ${isM ? 'bg-emerald-300' : 'bg-amber-300'}`}
              style={{ flex: '1 1 0', height: `${Math.max(4, amp * 100)}%` }} />
          ))}
        </div>
      )}
      <div className="relative px-1 py-0.5 flex items-center gap-0.5 h-full truncate z-10">
        <GripHorizontal className={`h-2.5 w-2.5 flex-shrink-0 ${isM ? 'text-emerald-300' : 'text-amber-300'}`} />
        <span className="text-[8px] text-white truncate flex-1 drop-shadow-sm">{segment.name}</span>
        <span className="text-[7px] text-white/70 flex-shrink-0 drop-shadow-sm">{segment.volume}%</span>
      </div>
    </div>
  );
};
